import React from "react";

import "./not-found.m.css";

function NotFoundPage() {
  return (
    <div styleName="wrapper">
      <h1 styleName="status">404</h1>
      <h2 styleName="status-message1">Oops.. Page not found !</h2>
      <p styleName="status-message2">
        The page you are looking for might have been removed, had its name changed, or is temporarily unavialable
      </p>
      <div>
        <a href="/" styleName="button">
          back to Home Page
        </a>
      </div>
    </div>
  );
}

export { NotFoundPage };
